import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { FundingReviewModel } from '../../cmg-1003/models/funding-review.model';
import { Cmg1003FundingReviewStore } from './funding-review.store';

@Injectable({ providedIn: 'root' })
export class Cmg1003FundingReviewQuery extends Query<FundingReviewModel> {
  protected store: Cmg1003FundingReviewStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(Cmg1003FundingReviewStore);

    super(store);

    this.store = store;
  }
}
